import { render, staticRenderFns } from "./EditorBtns.vue?vue&type=template&id=0dd8233b&scoped=true&"
import script from "./EditorBtns.vue?vue&type=script&lang=js&"
export * from "./EditorBtns.vue?vue&type=script&lang=js&"
import style0 from "./EditorBtns.vue?vue&type=style&index=0&id=0dd8233b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8233b",
  null
  
)

export default component.exports